import { useMediaQuery } from '@mui/material'
import React, { useEffect } from 'react'
import { UserContext, UserContextPayload } from '../../context/userContext';

const CustomPageIframe = () => {
    const mobileScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const { currentActiveMenu, currentActiveMobileMenu } = React.useContext(UserContext) as UserContextPayload;

    useEffect(() => {
        const popupIframe = document.getElementById("custom-pages-iframe-data");
        console.log(popupIframe, "popupIframe")

        if (!popupIframe) {
            // console.error("Iframe not found");
            return;
        }

        const sendMessageToChild = (params: any) => {
            const dataObj = {
                actionType: "custom-email-query-param",
                additionalData: params,
            };

            //@ts-ignore
            if (popupIframe?.contentWindow) {
                //@ts-ignore
                popupIframe.contentWindow.postMessage(dataObj, "*");
            }
        };

        const handleIframeLoad = () => {
            const urlParent = new URL(window.location.href);
            const queryParams: any = {};
            urlParent.searchParams.forEach((value, key) => {
                queryParams[key] = value;
            });
            sendMessageToChild(queryParams)
            // const id = urlParent.searchParams.get("mail_thread_id");
            // if (id) {
            //     sendMessageToChild(id);
            // }
        };

        // Listen to iframe load
        popupIframe.addEventListener("load", handleIframeLoad);

        // Setup listener from child to parent
        window.addEventListener("message", (event) => {
            const childData = event.data;
            console.log(childData, "childData")

            if (childData?.actionType === "mail-thread-id-change") {
                const threadId = childData.thread_id;
                const url = new URL(window.location.href);

                if (threadId) {
                    url.searchParams.set("thread_id", threadId);
                } else {
                    url.searchParams.delete("thread_id");
                }
                window.history.replaceState({}, "", url);
            }
        });

        return () => {
            popupIframe.removeEventListener("load", handleIframeLoad);
        };
    }, []);

    return (
        <div
            style={{ marginTop: "0px", minHeight: "calc(100vh - 10px)", padding: "1px", width: "100%" }}
            dangerouslySetInnerHTML={{ __html: mobileScreen ? `<iframe id="custom-pages-iframe-data" src=\"${process.env.REACT_APP_CUSTOM_BASE_URL}${currentActiveMobileMenu}\" width=\"100%\" style=\"height: 100%;min-height: calc(100vh - 250px);border-radius: 10px;\"frameborder=\"0\"></iframe>` : `<iframe id="custom-pages-iframe-data" src=\"${process.env.REACT_APP_CUSTOM_BASE_URL}${currentActiveMenu}\" width=\"100%\" style=\"height: 100%;min-height: calc(100vh - 250px);border-radius: 10px;\"frameborder=\"0\"></iframe>` }}
            // dangerouslySetInnerHTML={{ __html: mobileScreen ? `<iframe id="custom-pages-iframe-data" src=\"${process.env.REACT_APP_CUSTOM_BASE_URL}${currentActiveMobileMenu}\" width=\"100%\" style=\"height: 100%;min-height: calc(100vh - 250px);border-radius: 10px;\"frameborder=\"0\"></iframe>` : `<iframe id="custom-pages-iframe-data" src=\"http://localhost:8500/ai-email\" width=\"100%\" style=\"height: 100%;min-height: calc(100vh - 250px);border-radius: 10px;\"frameborder=\"0\"></iframe>` }}
        />
    )
}

export default CustomPageIframe
